import React, { Component } from "react";
import styled from "styled-components";
import { createUser } from "../utils/fb";
import { auth } from "../config";
import { ToastContainer, toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";

const Segment = styled.div`
  border: 1px solid #e7e9ed;
  margin-left: auto;
  margin-right: auto;
  width: 500px;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      success: false,
      error: "",
      captchaSuccess: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCaptcha = this.handleCaptcha.bind(this);
    this.notify = () =>
      toast("Go to your email address and verify your account.");
  }

  handleCaptcha(value) {
    this.setState({ captchaSuccess: true });
  }

  handleSubmit(e) {
    e.preventDefault();

    // must pass captcha
    if (!this.state.captchaSuccess) {
      return;
    }

    this.setState({ isLoading: true });

    createUser(this.email.value, this.password.value)
      .then(res => {
        this.setState({ isLoading: false });

        const user = auth.currentUser;
        user.updateProfile({
          displayName: `${this.firstname.value} ${this.lastname.value}`,
          firstname: this.firstname.value,
          lastname: this.lastname.value,
          phoneNumber: this.phone.value || ""
        });

        return user.sendEmailVerification();
      })
      .then(() => {
        this.notify();
        this.clearForm();
      })
      .catch(e => {
        this.setState({ error: e, isLoading: false });
      });
  }

  clearForm() {
    this.firstname.value = "";
    this.lastname.value = "";
    this.email.value = "";
    this.password.value = "";
    this.phone.value = "";
  }

  render() {
    const { isLoading } = this.state;
    return (
      <div className="mt3 ma3 pt3 mb4">
        <ToastContainer autoClose={false} position="top-center" />
        <Segment className="mt3 pa4 bg-white">
          <h1 className="f3 fw5 pb3 tc lh-copy">Register</h1>
          <form onSubmit={this.handleSubmit}>
            <div className="field">
              <label className="b">First Name</label>
              <input
                className="input"
                type="text"
                required
                ref={x => (this.firstname = x)}
              />
            </div>
            <div className="field">
              <label className="b">Surname</label>
              <input
                className="input"
                type="text"
                required
                ref={x => (this.lastname = x)}
              />
            </div>
            <div className="field">
              <label className="b">Phone number</label>
              <input className="input" type="tel" ref={x => (this.phone = x)} />
            </div>

            <div className="field">
              <label className="b">Email</label>
              <input
                className="input"
                type="email"
                required
                ref={x => (this.email = x)}
              />
            </div>
            <div className="field">
              <label className="b">Password</label>
              <input
                className="input"
                type="password"
                required
                ref={x => (this.password = x)}
              />
            </div>

            <ReCAPTCHA
              sitekey="6LcawEwUAAAAAGOC_qebUxjYPSFje3-eVVAkLk4P"
              ref="recaptcha"
              onChange={this.handleCaptcha}
            />

            <button
              type="submit"
              className={`button mt3 is-link ph5 ${isLoading && "is-loading"}`}
            >
              Submit
            </button>
          </form>
        </Segment>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/pages/register.js